export class BotScheduleTempVariable {
  botScheduleTempVariableId: any;
  botScheduleTempVariableStatus: any;
  botScheduleTempVarOrder: any;
  botScheduleTempVar: any;
  fkBotScheduleId: any;
  list: BotScheduleTempVariable[] = [];
}
